import Vue from 'vue'
import Router from 'vue-router'
import store from '@/vuex'
Vue.use(Router)
const router=new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/page/points')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/page/login')
    },
    {
      path: '/pointshistory',
      name: 'pointshistory',
      component: () => import('@/page/pointshistory')
    }
  ]
})

router.beforeEach((to, from,next) => {
    if((store.state.user.token==""||store.state.user.token==undefined) && to.name !== 'login'){
      store.commit("HIDE_LOADING")
      next({ name: 'login' })
    }else{
      next()
    }
})
router.afterEach(() => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
})

export function goTo(url){
    router.push(url).catch(()=>{}) 
}

export default router

